import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Properties from './components/Properties';
import Screenshots from './components/Screenshots';
import Download from './components/Download';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Properties />
        <Screenshots />
        <Download />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
